/**
 * React Query client configuration
 */

import { QueryClient } from "@tanstack/react-query";
import { suiteQueryRetry, throttleAwareRetryDelay } from "./throttleRetry";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      // One retry for ordinary failures; a 429 waits out its Retry-After
      // first and is not retried at all when that wait is over 60s (#1747 D4).
      retry: suiteQueryRetry,
      retryDelay: throttleAwareRetryDelay,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
